/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="systemToolbox.module.ts" />

module Meevo.Plugins.SystemToolbox {

    export class SystemToolboxController extends Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            "meevo.components.logging.LoggingService",
            '$scope',
            'meevo.ContextParams',
            '$state',
            '$rootScope',
            'meevo.components.short-cuts.ShortCutsService',
            '$http',
            '$q',
            '$translate',
            '$timeout',
            'meevo.components.busy.BusyService',
            'meevo.components.tracking.TrackingService',
            'meevo.components.common.SecurityService'
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected $scope: angular.IScope,
            protected contextParams: IContextParams,
            protected $state: any,
            protected $rootScope: angular.IRootScopeService,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $http: angular.IHttpService,
            protected $q: ng.IQService,
            protected $translate: ng.translate.ITranslateService,
            protected $timeout: ng.ITimeoutService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected securityChecker: Meevo.Components.Common.ISecurityService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
            this.context = new SystemToolboxContext(
                this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, securityChecker,
                this.trackingService, this.busyService, this.$rootScope, this.$translate, this.$q, this.$http, this.$timeout, this);
        }
    }

    angular.module("meevo.plugins.systemToolbox")
        .controller("meevo.plugins.systemToolbox.systemToolboxController", SystemToolboxController);
}